
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      title: "How To Pack A Bike | Bike Packing Instructions | Bikeflights.com",
      items: [
        {
          image: "bf-yt-how-to-assemble-box",
          title: "Introducing The New Bikeflights Bike Box",
          videoURL: "https://www.youtube.com/embed/wXBIJ6cHod0",
        },

        {
          image: "bf-packing-medium",
          title: "How to pack a Bikeflights Bike Box Medium",
          videoURL: "https://www.youtube.com/embed/IY7LU9wtrRc",
        },

        {
          image: "bf-thumb-packing-large",
          title: "How to pack a Bikeflights box with your MTB bike",
          videoURL: "https://www.youtube.com/embed/1NGepNxJs1s",
        },

        {
          image: "how_to_pack_a_hardcase_with_your_road_bike",
          title: "How to pack a hardcase with your road bike",
          videoURL: "https://www.youtube.com/embed/Snio42X0S7U",
        },

        {
          image: "how_to_pack_a_softcase_with_your_tri_bike",
          title: "How to pack a softcase with your tt/tri bike",
          videoURL: "https://www.youtube.com/embed/mkjOPuK9Hk4",
        },
      ],

      itemsSm: [
        {
          image: "bf-thumb-remove-label",
          title: "how to remove old labels",
          videoURL: "https://www.youtube.com/embed/it_SkjL5WGA",
        },

        {
          image: "bf-thumb-attach-label-box",
          title: "How to pack attach label to box",
          videoURL: "https://www.youtube.com/embed/47elsrW67HY",
        },

        {
          image: "bf-thumb-how-attach-label-case",
          title: "How to attach label to case",
          videoURL: "https://www.youtube.com/embed/vk9Raprw3uE",
        },

        {
          image: "bf-thumb-measure",
          title: "How to measure and weigh box",
          videoURL: "https://www.youtube.com/embed/sDgsFo1A--4",
        },

        {
          image: "bf-thumb-get-receipt",
          title: "How to request a shiiping receipt",
          videoURL: "https://www.youtube.com/embed/UOO1IuXLz_c",
        },

        {
          image: "bf-thumb-intro-select-aprop-box",
          title: "Selecting the right bike box",
          videoURL: "https://www.youtube.com/embed/ojg0iJiQd5I",
        },

        {
          image: "bf-thumb-protect-dropouts",
          title: "How to protect your dropouts",
          videoURL: "https://www.youtube.com/embed/GSRwyI8JwcI",
        },

        {
          image: "bf-thumb-protect-der",
          title: "How to protect rear derailleur",
          videoURL: "https://www.youtube.com/embed/2Dd-g-oIwGo",
        },

        {
          image: "bf-thumb-protect-frame",
          title: "How to protect your bike frame",
          videoURL: "https://www.youtube.com/embed/rcwmUV82VSM",
        },

        {
          image: "bf-thumb-protect-wheels",
          title: "How to protect-wheels",
          videoURL: "https://www.youtube.com/embed/Hh9zuWx5SVs",
        },

        {
          image: "bf-thumb-structural-support",
          title: "How to add structural support to your box",
          videoURL: "https://www.youtube.com/embed/HUQXA-1uEEg",
        },

        {
          image: "bf-thumb-secure-loose-parts",
          title: "How to secure loose-parts",
          videoURL: "https://www.youtube.com/embed/OZFtIhq_pKw",
        },
      ],

      isVisible: false,
      url: "",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },

  methods: {
    clickRight() {
      const container = this.$refs.container as Element;
      container.scrollLeft += 200;
    },

    clickLeft() {
      const container = this.$refs.container as Element;
      container.scrollLeft -= 200;
    },

    clickRightSm() {
      const container = this.$refs.containerSM as Element;
      container.scrollLeft += 200;
    },

    clickLeftSm() {
      const container = this.$refs.containerSM as Element;
      container.scrollLeft -= 200;
    },

    toggleModal(itemURL: any) {
      this.isVisible = !this.isVisible;
      this.url = itemURL;
    },
  },
});
